import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { startWith, takeUntil } from 'rxjs';

import { DisplayType, SummitIdObject } from '@summit/models';
import { BlurDirective } from '@summit/ui';
import { FloatLabel } from 'primeng/floatlabel';
import { InputNumber } from 'primeng/inputnumber';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input/s-form-error-input.component';

@Component({
  selector: 's-form-input-number',
  templateUrl: './s-form-input-number.component.html',
  styleUrls: ['./s-form-input-number.component.scss'],
  standalone: true,
  imports: [InputNumber, FloatLabel, ReactiveFormsModule, SFormErrorInputComponent, BlurDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormInputNumberComponent<T extends SummitIdObject> extends SummitControl<T> implements OnInit {
  @Input() prefix: string;
  @Input() displayType?: DisplayType;
  @Output() blurEvent = new EventEmitter<any>();
  @Input() maxFractionDigits = 2;
  readonly DisplayType = DisplayType;
  // myGroup: any;

  override ngOnInit() {
    super.ngOnInit();
    if (this.schema !== false) {
      this.attribute = this.schema?.getAttribute(this.fieldName ?? '', this.groupName);
      if (!this.attribute) {
        console.error(
          `Could not find Property: ${this.fieldName?.toString()} in group ${this.groupName} in Tree:`,
          this.schema
        );
      } else {
        this.displayType ??= this.attribute.displayType;
      }
    }
    if (this.displayType === null || this.displayType === undefined)
      console.warn(`WARNING: No display type was received for ${this.fieldName}`);

    if (this.displayType === DisplayType.Fuel) {
      this.maxFractionDigits = 3;
    }
    this.label ??= this.attribute?.displayName;
    this.displayHint ??= this.attribute?.displayHint ?? '';
    this.emitBlur(this.attribute);
    this.cd.detectChanges();
    if (this.fieldName) {
      this.form.controls[this.fieldName ?? '']?.valueChanges
        .pipe(startWith(this.form.controls[this.fieldName ?? '']?.value), takeUntil(this.disposing$))
        .subscribe((value) => {
          //console.log(`${this.fieldName}: watching value changes '${value}'`, value);
          if (value === '') {
            this.form.controls[this.fieldName ?? '']?.patchValue(null);
            this.cd.detectChanges();
          }
        });
    }
  }

  ShowDollarSign(): boolean {
    return (
      this?.displayType === DisplayType.Money ||
      this?.displayType === DisplayType.Rate ||
      this?.displayType === DisplayType.Financial
    );
  }

  showPercentage(): boolean {
    return this?.displayType === DisplayType.PercentageFromWholeNumber;
  }

  emitBlur($event) {
    //console.log(`${this.fieldName}: emitting blur event`, $event);
    this.blurEvent.emit($event);
  }
}
